import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { StickyComponent } from '../common/stickyComponent'
import { PERIOD_TYPE } from '../constant'
import { getHighlight } from '../store/thunk'
import Commentary from './components/bottomComponent/components/commentary'
import CorporateRiskScore from './components/bottomComponent/components/corporateRiskScore'
import RiskComponentAnalysis from './components/bottomComponent/components/riskComponentAnalysis'
import RiskScaleAndInterpretation from './components/bottomComponent/components/riskScaleAndInterpretation'
import { getRiskScaleInterpretationThunk } from './store/thunk'

const CorporateRiskScorePackage = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(getRiskScaleInterpretationThunk({}))
    dispatch(
      getHighlight({
        OrganizationId: params.organizationId,
        TimeFrequency: PERIOD_TYPE.YEARLY,
      }),
    )
  }, [params.organizationId])

  return (
    <div
      style={{
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: 1600 }}>
          <StickyComponent hiddenTimeFrequency />
          <RiskScaleAndInterpretation />
          <CorporateRiskScore hiddenDownload />
          <RiskComponentAnalysis hiddenDownload />
          <Commentary />
        </div>
      </div>
    </div>
  )
}

export default CorporateRiskScorePackage
